import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BudgetCollaborationService, BudgetComment } from '../../../services/budget-collaboration.service';
import { ContractsService } from '../../../services/contracts.service';
import { ErrorService } from '../../../shared/services/error.service';

export type CollaborationEntityKind = 'Budget' | 'Claim';

/**
 * Fio de conversa genérico (orçamento ou sinistro) visto pela equipe no ERP.
 */
@Component({
  selector: 'app-collaboration-comments',
  templateUrl: './collaboration-comments.component.html',
  styleUrls: ['./budget-collaboration.component.css']
})
export class CollaborationCommentsComponent implements OnChanges {
  @Input() entityType: CollaborationEntityKind = 'Budget';
  @Input() entityId: number | null = null;
  /** Contrato B2B — obrigatório quando entityType = Claim. */
  @Input() contractId: number | null = null;
  @Input() allowInternal = true;
  @Input() emptyLabel = 'Nenhum comentário neste fio.';

  comentarios: BudgetComment[] = [];
  loading = false;
  sending = false;

  mensagem = '';
  interno = false;

  constructor(
    private budgetCollab: BudgetCollaborationService,
    private contractsService: ContractsService,
    private errorService: ErrorService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['entityType'] || changes['entityId'] || changes['contractId']) {
      this.reset();
      this.load();
    }
  }

  load(): void {
    if (!this.entityId) return;
    if (this.entityType === 'Claim' && !this.contractId) return;

    this.loading = true;
    const req$ =
      this.entityType === 'Claim'
        ? this.contractsService.listB2bClaimComments(this.contractId!, this.entityId)
        : this.budgetCollab.listComments(this.entityId);

    req$.subscribe({
      next: res => {
        this.comentarios = res ?? [];
        this.loading = false;
      },
      error: err => {
        this.errorService.showErrorMessage(err?.message || 'Falha ao carregar comentários.');
        this.loading = false;
      }
    });
  }

  send(): void {
    const texto = this.mensagem.trim();
    if (!this.entityId || !texto || this.sending) return;
    if (this.entityType === 'Claim' && !this.contractId) return;

    this.sending = true;
    const body = { mensagem: texto, interno: this.allowInternal && this.interno };
    const req$ =
      this.entityType === 'Claim'
        ? this.contractsService.addB2bClaimComment(this.contractId!, this.entityId, body)
        : this.budgetCollab.addComment(this.entityId, body);

    req$.subscribe({
      next: novo => {
        this.comentarios = [...this.comentarios, novo];
        this.mensagem = '';
        this.sending = false;
        this.errorService.showSuccessMessage(
          novo.interno ? 'Comentário interno registrado.' : 'Comentário enviado.'
        );
      },
      error: err => {
        this.errorService.showErrorMessage(err?.message || 'Falha ao enviar comentário.');
        this.sending = false;
      }
    });
  }

  isCliente(c: BudgetComment): boolean {
    return c.autorOrigem === 'Portal';
  }

  isSistema(c: BudgetComment): boolean {
    return c.autorOrigem === 'System';
  }

  origemLabel(c: BudgetComment): string {
    if (this.isCliente(c)) return 'Cliente';
    if (this.isSistema(c)) return 'Automático';
    return 'Equipe';
  }

  private reset(): void {
    this.comentarios = [];
    this.mensagem = '';
    this.interno = false;
  }
}
